export default "__VITE_ASSET__CLJKUbmF__"